import { render, staticRenderFns } from "./FrequentAbsencesMail.vue?vue&type=template&id=86352e24"
import script from "./FrequentAbsencesMail.vue?vue&type=script&lang=js"
export * from "./FrequentAbsencesMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports